import React from 'react';
import { Link } from 'react-router-dom';
import './../../Subjects/Style/Subjects.css';
import TopNavbar from '../../home/TopNavbar';
import TopHeader from '../../home/TopHeader';

function PYQMockTestSubject() {

  
    const pageTitleText = "JEE PYQ Mock Tests";


    return (
        <>

            <div className="subject-page">

                <TopNavbar name={pageTitleText} />

                <TopHeader name={pageTitleText} />


                <div className="subject-categories">

                    <Link to={`/pyq-mock-test/${"mocktestpyq"}/${"all"}//${"Full"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                Δ
                            </div> 
                            <h2>Full  Mock Test  ➔</h2>
                        </div>

                    </Link>

                    <Link to={`/pyq-mock-test/${"mocktestpyq"}/${"math"}/${"Mathematics"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                🧬
                            </div>
                            <h2>Mathematics  ➔ </h2> 
                        </div>

                    </Link>

                    <Link to={`/pyq-mock-test/${"mocktestpyq"}/${"physics"}/${"Physics"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                ⚛
                            </div>
                            <h2>Physics  ➔</h2> 
                        </div>

                    </Link>

                    <Link to={`/pyq-mock-test/${"mocktestpyq"}/${"chemistry"}/${"Chemistry"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                ⚗
                            </div>
                            <h2>Chemistry  ➔ </h2> 
                        </div>

                    </Link>

                    
                </div>
            </div>
        </>
    );
}

export default PYQMockTestSubject;